import React, { FC } from 'react';
import { IMRBeaconSVGProps } from './icons.types';

const Group: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <g id="calendar">
          <rect
            id="Rectangle-path"
            x="1.33337"
            y="2.66797"
            width="15.3333"
            height="14"
            rx="1"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape"
            d="M4.66675 1.33594V4.66927"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_2"
            d="M13.3334 1.33594V4.66927"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Shape_3"
            d="M1.33337 6.00391H16.6667"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default Group;
